import React, { useEffect, useCallback } from 'react';
import { Box } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import Navbar from './Navbar';
import PageBackButton from './PageBackButton';
import { authService } from '../services/authService';
import { API_BASE_URL } from '../config';

const Layout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = authService.getCurrentUser() || {};

  useEffect(() => {
    if (!authService.isAuthenticated()) {
      navigate('/login');
      return;
    }
    const syncProfile = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${API_BASE_URL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        authService.setCurrentUser(response.data);
      } catch {
        // keep cached profile if refresh fails
      }
    };
    syncProfile();
  }, [navigate]);

  const handleBack = useCallback(() => {
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }
    navigate(user.role === 'admin' ? '/reports' : '/display', { replace: true });
  }, [location.key, navigate, user.role]);

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f7f8fa' }}>
      <Navbar />
      <Box
        sx={{
          position: 'fixed',
          left: { xs: 12, sm: 16, md: 24 },
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 1200,
        }}
      >
        <PageBackButton onClick={handleBack} />
      </Box>
      <Box sx={{ p: { xs: 1.5, sm: 2, md: 3 }, width: '100%', boxSizing: 'border-box' }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;
